import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, ArrowRight } from 'lucide-react';

const FloatingQuoteButton = ({ onClick }) => {
  return (
    <motion.button
      onClick={onClick}
      className="fixed bottom-8 bg-gradient-to-r from-orange-400 to-orange-500 text-white px-8 py-3 rounded-xl shadow-2xl hover:shadow-3xl z-40 flex items-center gap-2 group font-semibold"
      style={{left: '32px'}}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5, delay: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      data-testid="floating-quote-button"
    >
      <MessageSquare size={18} className="group-hover:rotate-12 transition-transform" />
      <span className="hidden md:inline">Get Quote</span>
      <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
      
      {/* Pulse animation */}
      <motion.div
        className="absolute inset-0 rounded-xl bg-orange-300"
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.5, 0, 0.5]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </motion.button>
  );
};

export default FloatingQuoteButton;
